import { render, staticRenderFns } from "./PlatformFeedbackTable.vue?vue&type=template&id=6c7921cb&"
import script from "./PlatformFeedbackTable.vue?vue&type=script&lang=js&"
export * from "./PlatformFeedbackTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
installComponents(component, {VRating})
